/**
 * 表单验证工具
 */

/**
 * 验证手机号（中国大陆手机号）
 */
export const validateMobile = (mobile: string): { valid: boolean; error?: string } => {
  if (!mobile) {
    return { valid: false, error: '请输入手机号' };
  }
  
  // 中国大陆手机号正则：1开头，第二位是3-9，共11位
  const mobileRegex = /^1[3-9]\d{9}$/;
  
  if (!mobileRegex.test(mobile)) {
    return { valid: false, error: '请输入正确的手机号' };
  }
  
  return { valid: true };
};

/**
 * 验证密码
 */
export const validatePassword = (password: string): { valid: boolean; error?: string } => {
  if (!password) {
    return { valid: false, error: '请输入密码' };
  }
  
  if (password.length < 6) {
    return { valid: false, error: '密码不能少于6位' };
  }
  
  return { valid: true };
};

/**
 * 验证确认密码
 */
export const validateConfirmPassword = (password: string, confirmPassword: string): { valid: boolean; error?: string } => {
  if (!confirmPassword) {
    return { valid: false, error: '请确认密码' };
  }
  
  if (password !== confirmPassword) {
    return { valid: false, error: '两次输入的密码不一致' };
  }
  
  return { valid: true };
};

